import { useEffect } from 'react';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { initFrontendAppInsights } from './appInsights';

/**
 * Initialise frontend Application Insights using the runtime config served
 * by `@backstage/plugin-app-backend`. The connection string is a runtime
 * container env var (`APPLICATIONINSIGHTS_CONNECTION_STRING`), so it must
 * be read at boot via configApi — not from the build-time `process.env`
 * blob, which is empty when the image is built in CI.
 */
export function AppInsightsBootstrap(): null {
  const configApi = useApi(configApiRef);

  useEffect(() => {
    initFrontendAppInsights(
      configApi.getOptionalString('app.applicationInsightsConnectionString'),
    );
  }, [configApi]);

  return null;
}
